var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layer layer--block" }, [
    _c("div", { staticClass: "layer--block__title" }, [
      _c("h3", [_vm._v(_vm._s(_vm.layer.name))]),
      _vm._v(" "),
      _vm.isToggleable && !_vm.isStatic
        ? _c(
            "button",
            {
              staticClass: "button button--toggle",
              class: { active: _vm.isVisibleOrActive },
              attrs: {
                role: "button",
                title: _vm.$t("layer_toggle"),
                tabindex: "-1",
              },
              on: { click: _vm.onToggleLayer },
            },
            [_vm._v(_vm._s(_vm.$t("layer_toggle")))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.isVisibleOrActive
      ? _c("div", { staticClass: "layer--block__content" }, [
          _c(
            "form",
            { attrs: { action: "", method: "POST", novalidation: "" } },
            [
              _c("div", { staticClass: "grid-x grid-margin-x" }, [
                _c("div", { staticClass: "cell large-3" }, [
                  _vm.isStatic
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-control form-control--static form-control--small",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "placementtype." +
                                    _vm.value.$model.placement_type
                                )
                              )
                            ),
                          ]
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error":
                              _vm.value.placement_type.$error,
                          },
                        },
                        [
                          _c("v-select-layer-placement-type", {
                            staticClass: "form-control--small",
                            attrs: {
                              name: "placement_type",
                              placeholder: _vm.$t(
                                "form.project.layer.placement_type.plc"
                              ),
                            },
                            on: { change: _vm.onChangePlacementType },
                            model: {
                              value: _vm.value.$model.placement_type,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.$model,
                                  "placement_type",
                                  $$v
                                )
                              },
                              expression: "value.$model.placement_type",
                            },
                          }),
                        ],
                        1
                      ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell large-4" }, [
                  _vm.isStatic
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-control form-control--static form-control--small",
                          },
                          [_vm._v(_vm._s(_vm.value.$model.subtype))]
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.value.subtype.$error,
                          },
                        },
                        [
                          _c("v-select-layer-sub-type", {
                            attrs: {
                              name: "subtype",
                              type: _vm.layer.layer_key,
                              className:
                                "form-control--small " +
                                _vm.defaultSubTypeClass,
                              placeholder: _vm.$t(
                                "form.project.layer.subtype.plc"
                              ),
                            },
                            on: { change: _vm.onUpdateLayerSubType },
                            model: {
                              value: _vm.value.$model.subtype,
                              callback: function ($$v) {
                                _vm.$set(_vm.value.$model, "subtype", $$v)
                              },
                              expression: "value.$model.subtype",
                            },
                          }),
                        ],
                        1
                      ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell large-2" }, [
                  _vm.isStatic
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-control form-control--static form-control--small",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.value.$model.thickness) +
                                " " +
                                _vm._s(_vm.$t("cm"))
                            ),
                          ]
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.value.thickness.$error,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.$model.thickness,
                                expression: "value.$model.thickness",
                              },
                            ],
                            staticClass: "form-control form-control--small",
                            attrs: {
                              type: "text",
                              name: "thickness",
                              placeholder: _vm.$t(
                                "form.project.layer.thickness.plc"
                              ),
                            },
                            domProps: { value: _vm.value.$model.thickness },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value.$model,
                                  "thickness",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell large-3" }, [
                  _vm.isStatic
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-control form-control--static form-control--small",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.value.$model.qm) +
                                " " +
                                _vm._s(_vm.$t("qm"))
                            ),
                          ]
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { "form-group--error": _vm.value.qm.$error },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.$model.qm,
                                expression: "value.$model.qm",
                              },
                            ],
                            staticClass: "form-control form-control--small",
                            attrs: {
                              type: "text",
                              name: "qm",
                              placeholder: _vm.$t(
                                "form.project.layer.area.plc"
                              ),
                            },
                            domProps: { value: _vm.value.$model.qm },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value.$model,
                                  "qm",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                ]),
              ]),
              _vm._v(" "),
              _vm.isStatic
                ? _vm._l(_vm.logs, function (log, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "grid-x grid-margin-x" },
                      [
                        _c("div", { staticClass: "cell large-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-control form-control--static-hidden form-control--small",
                              },
                              [
                                _c("span", {
                                  staticClass: "status-icon",
                                  class: "status-icon--" + log.status,
                                }),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.$t("status." + log.status))
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell large-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-control form-control--static-hidden form-control--small",
                              },
                              [
                                log.date.date !== null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            log.date.date,
                                            _vm.$helpers.dateFormat.toUpperCase()
                                          )
                                        )
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell large-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-control form-control--static-hidden form-control--small",
                              },
                              [
                                _vm._v(
                                  _vm._s(log.qm) + " " + _vm._s(_vm.$t("qm"))
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }